(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyran-buybox-cream"]) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.vyrInit === '1') return;
    root.dataset.vyrInit = '1';

    var cfg      = JSON.parse(root.querySelector('[data-vyr-config]').textContent);
    var swatchEl = root.querySelector('[data-vyr-swatches]');
    var swatches = swatchEl ? JSON.parse(swatchEl.textContent) : {};
    var notesEl  = root.querySelector('[data-vyr-shadenotes]');
    var notes    = notesEl ? JSON.parse(notesEl.textContent) : {};
    var form     = root.querySelector('[data-vyr-form]');
    var atc      = root.querySelector('[data-vyr-atc]');
    var atcText  = root.querySelector('[data-vyr-atc-text]');
    var atcLabel = atcText ? atcText.textContent : '';

    function selectedTier() {
      var i = root.querySelector('input[name="vyr-pack"]:checked');
      if (!i) return null;
      var all = root.querySelectorAll('[data-vyr-pack]');
      for (var k = 0; k < all.length; k++) if (all[k].dataset.vyrPack === i.value) return all[k];
      return null;
    }

    // la pastille de teinte suit le libellé choisi, pas l'id de variante
    function paintSwatches() {
      root.querySelectorAll('.vyr-swatch').forEach(function (w) {
        var sel = w.querySelector('select');
        var thumb = w.querySelector('[data-vyr-swatchthumb]');
        if (!sel || !thumb) return;
        var name = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text : '';
        var note = w.parentNode.querySelector('[data-vyr-shadenote]');
        if (note) { note.textContent = notes[name] || ''; note.hidden = !notes[name]; }
        var url = swatches[name];
        if (url) thumb.style.backgroundImage = 'url("' + url + '")';
      });
    }
    var swapEl = root.querySelector('[data-vyr-soldswap]');
    var swaps = {};
    try { swaps = swapEl ? JSON.parse(swapEl.textContent) : {}; } catch (e) { swaps = {}; }

    // pastilles : la teinte choisie suit le <select> caché du palier (le guide de teinte écrit dedans)
    function syncChips(box) {
      var all = box && box.querySelector('[data-vyr-shade-all]');
      if (!all) return;
      box.querySelectorAll('[data-vyr-chip]').forEach(function (c) {
        var on = c.getAttribute('data-so') !== '1' && c.getAttribute('data-vyr-chip') === all.value;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (box.getAttribute('data-vyr-mixed') !== '1') {
        box.querySelectorAll('[data-vyr-shade-one]').forEach(function (s) { s.value = all.value; });
      }
    }
    function pick(box, id, msg) {
      var all = box.querySelector('[data-vyr-shade-all]');
      if (!all) return;
      all.value = String(id);
      all.dispatchEvent(new Event('change', { bubbles: true }));
      var note = box.querySelector(':scope > [data-vyr-shadenote]');
      if (note) { note.textContent = msg || ''; note.hidden = !msg; }
    }

    root.addEventListener('change', function (e) {
      if (!e.target.hasAttribute) return;
      if (e.target.hasAttribute('data-vyr-shade-all')) {
        var box = e.target.closest('[data-vyr-shadebox]');
        if (box) syncChips(box);
      }
      if (e.target.hasAttribute('data-vyr-shade') || e.target.hasAttribute('data-vyr-shade-one')) paintSwatches();
    });
    root.addEventListener('click', function (e) {
      var chip = e.target.closest && e.target.closest('[data-vyr-chip]');
      if (chip) {
        e.preventDefault();
        var box = chip.closest('[data-vyr-shadebox]');
        if (!box) return;
        if (chip.getAttribute('data-so') === '1') {
          // rupture : on choisit la remplaçante et on le dit
          var sw = swaps[chip.getAttribute('data-name')];
          var to = sw && box.querySelector('[data-vyr-chip][data-name="' + sw.to + '"]:not([data-so])');
          if (to) pick(box, to.getAttribute('data-vyr-chip'), sw.msg);
          else {
            var n0 = box.querySelector(':scope > [data-vyr-shadenote]');
            if (n0) { n0.textContent = chip.getAttribute('data-name') + ' – ' + (chip.querySelector('.vyr-chip__so') || {}).textContent; n0.hidden = false; }
          }
          return;
        }
        pick(box, chip.getAttribute('data-vyr-chip'), '');
        return;
      }
      var btn = e.target.closest && e.target.closest('[data-vyr-mixbtn]');
      if (!btn) return;
      e.preventDefault();
      var mbox = btn.closest('[data-vyr-shadebox]');
      if (!mbox) return;
      var rows = mbox.querySelector('[data-vyr-mixrows]');
      var chips = mbox.querySelector('[data-vyr-chips]');
      var all = mbox.querySelector('[data-vyr-shade-all]');
      var gl = mbox.querySelector('[data-vyr-glabel]');
      var on = mbox.getAttribute('data-vyr-mixed') !== '1';
      mbox.setAttribute('data-vyr-mixed', on ? '1' : '0');
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (rows) rows.hidden = !on;
      // en mélange, les pastilles « pour tous les tubes » ne comptent plus : on les retire de la vue
      if (chips) chips.hidden = on;
      var nt = mbox.querySelector(':scope > [data-vyr-shadenote]');
      if (nt && on) nt.hidden = true;
      if (gl) { if (!gl.dataset.one) gl.dataset.one = gl.textContent; gl.textContent = on ? 'Shade per tube' : gl.dataset.one; }
      btn.textContent = on ? 'One shade for all tubes' : 'Mix shades';
      if (!on && all) mbox.querySelectorAll('[data-vyr-shade-one]').forEach(function (x) { x.value = all.value; });
      paintSwatches();
    });

    // A/B : l'offre vue part sur le panier (donc sur la commande) avant que le tiroir ne se
    // redessine — c'est ce qui lui fait afficher le libellé de l'offre vue. Jamais plus
    // d'1,5 s d'attente : le tiroir s'ouvre quoi qu'il arrive.
    function abAfterAdd(units) {
      var ab = window.vyrAB;
      if (!ab || !ab.on) return Promise.resolve();
      try { ab.beacon('atc', units); } catch (e) {}
      var upd = fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { _vyr_ab: ab.arm, _vyr_test: ab.test, _vyr_qa: ab.qa ? '1' : '' } })
      }).catch(function () {});
      var cap = new Promise(function (res) { setTimeout(res, 1500); });
      return Promise.race([upd, cap]);
    }

    // Le pack part au panier en N lignes de la variante à l'unité : c'est ce qui donne
    // le détail par teinte dans le panier et la remise visible au checkout.
    if (atc) {
      atc.addEventListener('click', function (e) {
        e.preventDefault();
        var tier = selectedTier();
        if (!tier || (atc && atc.disabled)) return;

        var counts = {};
        var units = parseInt(tier.getAttribute('data-vyr-units'), 10) || 1;
        var box = tier.querySelector('[data-vyr-shadebox]');
        if (box && box.getAttribute('data-vyr-mixed') === '1') {
          tier.querySelectorAll('[data-vyr-shade-one]').forEach(function (sel) {
            if (sel.value) counts[sel.value] = (counts[sel.value] || 0) + 1;
          });
        } else {
          // une teinte pour tous les tubes du palier
          var one = box && box.querySelector('[data-vyr-shade-all]');
          if (one && one.value) counts[one.value] = units;
        }
        var items = Object.keys(counts).map(function (id) {
          return { id: Number(id), quantity: counts[id] };
        });
        if (!items.length) return;
        // Test 2 (08/10) : plus de guide offert, dans aucune offre.

        if (atc) atc.disabled = true;
        if (atcText && cfg.adding) atcText.textContent = cfg.adding;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) return r.text().then(function (t) { throw new Error(t); });
          if (atc) atc.disabled = false;
          if (atcText) atcText.textContent = atcLabel;
          // le tiroir custom (section vyran-cart-v4) est le panier du site ;
          // /cart n'est qu'un repli si son script n'a pas chargé.
          return abAfterAdd(units).then(function () {
            if (window.vyrCart && window.vyrCart.refresh) return window.vyrCart.refresh(true);
            window.location.href = cfg.cartUrl || '/cart';
          });
        }).catch(function (err) {
          if (atc) atc.disabled = false;
          if (atcText) atcText.textContent = atcLabel;
          console.error('[cart] add to cart failed', err);
        });
      });
    }

    // guide (réglage size_guide_text + image) : le bouton ouvre la modale, la croix ou le fond la ferme
    var sgBtn = root.querySelector('[data-vyr-sizeguide]'), sgDlg = root.querySelector('[data-vyr-sgmodal]');
    if (sgBtn && sgDlg && typeof sgDlg.showModal === 'function') {
      sgBtn.addEventListener('click', function () { if (!sgDlg.open) sgDlg.showModal(); });
      sgDlg.addEventListener('click', function (e) {
        if (e.target === sgDlg || (e.target.closest && e.target.closest('[data-vyr-sgclose]'))) sgDlg.close();
      });
    }

    // galerie : vignettes + flèches, inchangé
    var stage = root.querySelector('[data-vyr-stage]');
    var thumbs = root.querySelectorAll('[data-vyr-thumb]');
    function goTo(i) {
      var s = root.querySelector('[data-vyr-slide="' + i + '"]');
      if (s && stage) stage.scrollTo({ left: s.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(t.dataset.vyrThumb); }); });
    function activeIndex() {
      var a = root.querySelector('[data-vyr-thumb].is-active');
      return a ? parseInt(a.dataset.vyrThumb, 10) : 0;
    }
    var tp = root.querySelector('[data-vyr-tprev]'), tn = root.querySelector('[data-vyr-tnext]');
    if (tp) tp.addEventListener('click', function () { goTo(Math.max(0, activeIndex() - 1)); });
    if (tn) tn.addEventListener('click', function () { goTo(Math.min(thumbs.length - 1, activeIndex() + 1)); });
    if (stage && thumbs.length) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          thumbs.forEach(function (t) {
            var on = t.dataset.vyrThumb === en.target.dataset.vyrSlide;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        });
      }, { root: stage, threshold: 0.6 });
      root.querySelectorAll('[data-vyr-slide]').forEach(function (s) { io.observe(s); });
    }

    paintSwatches();
  }
  function boot() { document.querySelectorAll('[data-vyr-buy]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyran-reviewapp"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.vyrRaInit === '1') return;
    root.dataset.vyrRaInit = '1';

    root.querySelectorAll('[data-vyr-ramore]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var extra = btn.parentNode.querySelector('.vyr-ra__txt--more');
        if (!extra) return;
        var open = !extra.hidden;
        extra.hidden = open;
        var ell = btn.parentNode.querySelector('[data-vyr-raell]');
        if (ell) ell.style.display = open ? '' : 'none';
        btn.textContent = open ? 'More' : 'Less';
      });
    });

    var strip = root.querySelector('[data-vyr-rastrip]');
    var stripNext = root.querySelector('[data-vyr-rastripnext]');
    if (strip && stripNext) {
      stripNext.addEventListener('click', function () {
        var end = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 4;
        strip.scrollLeft = end ? 0 : strip.scrollLeft + 178;
      });
    }

    var show = root.querySelector('[data-vyr-rashow]');
    if (show) {
      show.addEventListener('click', function () {
        if (root.dataset.vyrWall === '1') return; // mur branché : assets/vyran-reviews.js gère « Show more » (filtres compris)
        var hidden = root.querySelectorAll('.vyr-ra__item.is-hidden');
        for (var i = 0; i < 12 && i < hidden.length; i++) hidden[i].classList.remove('is-hidden');
        if (root.querySelectorAll('.vyr-ra__item.is-hidden').length === 0) show.style.display = 'none';
      });
    }
  }
  function boot() { document.querySelectorAll('.vyr-ra').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyran-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.vyrRevInit === '1') return;
    root.dataset.vyrRevInit = '1';
    var rail = root.querySelector('[data-vyr-rail]');
    if (!rail) return;
    var cards = [].slice.call(rail.children);
    var dotsBox = root.querySelector('[data-vyr-dots]');
    var prev = root.querySelector('[data-vyr-prev]');
    var next = root.querySelector('[data-vyr-next]');

    function go(i) {
      var c = cards[Math.max(0, Math.min(cards.length - 1, i))];
      if (c) rail.scrollTo({ left: c.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
    }
    function current() {
      var best = 0, min = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft - rail.offsetLeft - rail.scrollLeft);
        if (d < min) { min = d; best = i; }
      });
      return best;
    }
    if (dotsBox) {
      cards.forEach(function (c, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vyr-rev__dot' + (i === 0 ? ' is-on' : '');
        b.setAttribute('aria-label', 'Review ' + (i + 1));
        b.addEventListener('click', function () { go(i); });
        dotsBox.appendChild(b);
      });
    }
    function paint() {
      var i = current();
      if (dotsBox) [].slice.call(dotsBox.children).forEach(function (d, j) {
        d.classList.toggle('is-on', j === i);
      });
    }
    rail.addEventListener('scroll', function () {
      window.clearTimeout(rail._t);
      rail._t = window.setTimeout(paint, 90);
    });
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
  }
  function boot() { document.querySelectorAll('.vyr-rev').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyran-trustwall"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.vyrTwInit === '1') return;
    root.dataset.vyrTwInit = '1';
    var rail = root.querySelector('[data-vyr-twrail]');
    if (!rail) return;
    var cards = [].slice.call(rail.children);
    function current() {
      var best = 0, min = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft - rail.offsetLeft - rail.scrollLeft);
        if (d < min) { min = d; best = i; }
      });
      return best;
    }
    function go(i) {
      var c = cards[Math.max(0, Math.min(cards.length - 1, i))];
      if (c) rail.scrollTo({ left: c.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
    }
    /* une flèche = une page de cartes, comme chez la référence */
    function step() { return window.innerWidth >= 990 ? 3 : 1; }
    var prev = root.querySelector('[data-vyr-twprev]');
    var next = root.querySelector('[data-vyr-twnext]');
    if (prev) prev.addEventListener('click', function () { go(current() - step()); });
    if (next) next.addEventListener('click', function () { go(current() + step()); });
  }
  function boot() { document.querySelectorAll('.vyr-tw').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyran-ugc-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.vyrUgcInit === '1') return;
    root.dataset.vyrUgcInit = '1';
    root.querySelectorAll('[data-vyr-video]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var holder = btn.parentNode;
        var v = document.createElement('video');
        v.className = 'vyr-ugc__vid';
        v.poster = btn.querySelector('img') ? btn.querySelector('img').src : '';
        v.src = btn.dataset.vyrVideo;
        v.controls = true;
        v.autoplay = true;
        v.muted = true;
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        holder.replaceChild(v, btn);
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }, { once: true });
    });
  }
  function boot() { document.querySelectorAll('.vyr-ugc').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyran-video-gallery"]) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.vyrVgInit === '1') return;
    root.dataset.vyrVgInit = '1';
    var vids = root.querySelectorAll('[data-vyr-vgv]');
    if (!('IntersectionObserver' in window)) {           // repli : on charge tout
      vids.forEach(function (v) {
        var s = v.querySelector('source');
        if (s && !s.src) { s.src = s.dataset.src; v.load(); }
        v.play().catch(function () {});
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target, s = v.querySelector('source');
        if (e.isIntersecting) {
          if (s && !s.src) { s.src = s.dataset.src; v.load(); }
          v.play().catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { rootMargin: '150px', threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }
  function boot() { document.querySelectorAll('.vyr-vg').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();
})();
